import { parsePhoneNumberFromString } from "libphonenumber-js";

/**
 * Count digits in a string
 * @param {string} str
 * @returns {number}
 */
export const countDigits = (str = "") =>
  str.replace(/\D/g, "").length;

/**
 * Validate phone number
 * @param {string} phone
 * @returns {{ isValid: boolean, error?: string }}
 */
export const validatePhone = (phone) => {
  if (!phone?.trim()) {
    return { isValid: true }; // optional field
  }

  //  Reject if phone starts with invalid characters
  if (!/^[+\d]/.test(phone)) {
    return {
      isValid: false,
      error: "Phone number must start with a country code (+) or a digit.",
    };
  }

  //  Reject multiple consecutive special characters
  if (/[-\s().]{2,}/.test(phone)) {
    return {
      isValid: false,
      error: "Invalid phone number format.",
    };
  }

  const parsed = parsePhoneNumberFromString(phone);

  if (!parsed || !parsed.isValid()) {
    return {
      isValid: false,
      error:
        "Select country code and enter a valid phone number.",
    };
  }

  return { isValid: true };
};
